/* LS-custom-mobile-filters.js
   Monta todos los [data-ls-bubbles] dentro del slot universal .ls-bubbles-slot
   Funciona igual en desktop y mobile, y soporta el editor de temas de Shopify.
*/
(function(){
  'use strict';

  var SLOT_SELECTOR = '.ls-bubbles-slot';

  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }

  function debounce(fn, wait){
    var t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function getSlot(){ return qs(SLOT_SELECTOR); }

  function mount(el){
    var slot = getSlot();
    if (!el || !slot) return;
    if (!slot.contains(el)) {
      slot.appendChild(el); // respeta el orden de los sections
      if (slot.scrollLeft !== 0) slot.scrollLeft = 0; // arranca a la izquierda
    }
  }

  function mountAll(){
    var slot = getSlot();
    if (!slot) return;
    qsa('[data-ls-bubbles]').forEach(mount);
  }

  // Exponer por si necesitás dispararlo manualmente desde consola
  window.LSCustomFilters = window.LSCustomFilters || {};
  window.LSCustomFilters.mountBubbles = mountAll;

  var schedule = debounce(mountAll, 32);

  function init(){
    mountAll();

    // Eventos del editor de Shopify
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:reorder', schedule);
    document.addEventListener('shopify:section:select', schedule);
    document.addEventListener('shopify:section:deselect', schedule);
    document.addEventListener('shopify:block:select', schedule);
    document.addEventListener('shopify:block:deselect', schedule);

    // Si el slot o el toolbar se re-renderizan
    var mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, {childList:true, subtree:true});

    // Por cambios de layout en resize
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
